interface MarketingCTAProps {
  children?: React.ReactNode
}

export function MarketingCTA({ children }: MarketingCTAProps) {
  return (
    <div className="bg-brand-gradient">
      <div className="mx-auto max-w-5xl px-6 py-12  lg:px-8">{children}</div>
    </div>
  )
}
